const debounce = (callback, wait) => {
  let timeoutId = null;
  return (...args) => {
      window.clearTimeout(timeoutId);
      timeoutId = window.setTimeout(() => {
      callback.apply(null, args);
      }, wait);
  };
}

function trapFocus(modal) {
  const focusableSelectors = `
    a[href], area[href], input:not([disabled]),
    select:not([disabled]), textarea:not([disabled]),
    button:not([disabled]), [tabindex]:not([tabindex="-1"])`;
  const focusableElements = Array.from(modal.querySelectorAll(focusableSelectors));

  if (focusableElements.length === 0) {
    console.warn('No focusable elements found in the modal.');
    return;
  }

  const firstFocusableElement = focusableElements[0];
  const lastFocusableElement = focusableElements[focusableElements.length - 1];

  function handleFocusTrap(event) {
    const isTabPressed = event.key === 'Tab';

    if (!isTabPressed) return;
    if (event.shiftKey) {
      if (document.activeElement === firstFocusableElement) {
        lastFocusableElement.focus();
        event.preventDefault();
      }
    } else {
      if (document.activeElement === lastFocusableElement) {
        firstFocusableElement.focus();
        event.preventDefault();
      }
    }
  }
  modal.addEventListener('keydown', handleFocusTrap);
  firstFocusableElement.focus();
  firstFocusableElement.blur();
  
  return function cleanupFocusTrap() {
    modal.removeEventListener('keydown', handleFocusTrap);
  };
}



const addToCart = async (productForm) => {
  const formData = new FormData(productForm);    
  formData.append('sections', 'inner-cart');
  
  const cart = fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    body: formData
  })
    .then((response) => response.json())
    .then((json) => json)
    .catch((err) => console.error(err));
    
  return cart;
}

const updateQty = async (id, qty) => {
  const updates = {};
  updates[id] = qty;

  const data = {
    updates,
    sections: ['inner-cart'],
  };

  const cart = fetch('/cart/update.js', {
    method: 'POST',
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .catch((error) => {
      console.error('Error:', error);
    });

  return cart;
};

// small scroll to section function
document.addEventListener('click', (event) => {
  const scrollTrigger = event.target.closest('[data-scroll-to]');
  if (scrollTrigger) {
    const scrollTarget = scrollTrigger.getAttribute('data-scroll-to');
    const targetElement = document.getElementById(scrollTarget);
    if (targetElement) {
      event.preventDefault();
      targetElement.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  }
});


// ─── Generic Swiper carousel init ────────────────────────────────────────────
// Add data-swiper-loop to any swiper-container with init="false".
// Options are read from existing HTML attributes
// breakpoints and inject-styles are parsed from their JSON attribute values.
(function () {
  var attrMap = {
    'slides-per-view':    ['slidesPerView',    parseFloat],
    'space-between':      ['spaceBetween',      parseInt],
    'grab-cursor':        ['grabCursor',        function (v) { return v !== 'false'; }],
    'loop':               ['loop',              function (v) { return v !== 'false'; }],
    'centered-slides':    ['centeredSlides',    function (v) { return v !== 'false'; }],
    'slides-offset-before': ['slidesOffsetBefore', parseInt],
  };

  function initSwiperEl(el) {
    var options = {};

    for (var attr in attrMap) {
      if (el.hasAttribute(attr)) {
        var cfg = attrMap[attr];
        options[cfg[0]] = cfg[1](el.getAttribute(attr));
      }
    }

    var bp = el.getAttribute('breakpoints');
    if (bp) { try { options.breakpoints = JSON.parse(bp); } catch (e) {} }

    var is = el.getAttribute('inject-styles');
    if (is) { try { options.injectStyles = JSON.parse(is); } catch (e) {} }

    // Disable Swiper's a11y module — it sets tabindex="-1" on non-active slides
    options.a11y = false;
    options.keyboard = { enabled: true, onlyInViewport: false };
    // Allow clicks to bubble and reach document listeners (needed for video play/pause)
    options.preventClicksPropagation = false;
    options.preventClicks = false;

    Object.assign(el, options);
    el.initialize();

    requestAnimationFrame(function () {
      if (!el.swiper) return;
      el.swiper.slideToLoop(0, 0);
      el.swiper.once('touchStart', function () {
        el.querySelectorAll('swiper-slide > *:first-child').forEach(function (s) {
          s.classList.remove('animate-reveal-up-short');
          s.style.opacity = '';
        });
      });

      // Tab: scroll carousel to whichever slide just received focus
      el.querySelectorAll('[data-hover-tile]').forEach(function (tile) {
        tile.addEventListener('focus', function () {
          var slide = tile.closest('swiper-slide');
          if (!slide) return;
          var idx = parseInt(slide.dataset.swiperSlideIndex, 10);
          if (!isNaN(idx)) el.swiper.slideToLoop(idx, 300);
        });
      });

      // Arrow keys: once the slide transition ends, focus the active tile
      el.swiper.on('keyPress', function (swiper, keyCode) {
        if (keyCode !== 37 && keyCode !== 39) return;
        el.swiper.once('slideChangeTransitionEnd', function () {
          var activeSlide = el.swiper.slides[el.swiper.activeIndex];
          if (!activeSlide) return;
          var tile = activeSlide.querySelector('[data-hover-tile]');
          if (tile) tile.focus({ preventScroll: true });
        });
      });

    });
  }

  function revealPeekSlides(el) {
    el.querySelectorAll('swiper-slide > *:first-child').forEach(function (s) {
      var r = s.getBoundingClientRect();
      if (r.right > 0 && r.left < window.innerWidth) s.style.opacity = '';
    });
  }

  function initAll(root) {
    (root || document).querySelectorAll('[data-swiper-loop]').forEach(function (el) {
      initSwiperEl(el);
      setTimeout(function () { revealPeekSlides(el); }, 300);
    });
  }

  initAll();

  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
})();


window.addEventListener('submit', (e) => {
  const productForm = e.target.closest(`[action="${Shopify.routes.root}cart/add"]`);
  if(!productForm) return;
  e.preventDefault();

  window.dispatchEvent(new CustomEvent('modal:openById', { 
    detail: 'minicart'
  }));
  
  const minicart = document.querySelector('mini-cart');
  if (minicart) minicart.classList.add('loading');
  
  addToCart(productForm)
    .then((cart) => {
      window.dispatchEvent(new CustomEvent('productForm:add', { 
        detail: cart
      }));
      
      if (!minicart) return;
      minicart.classList.remove('loading');
    })
    .catch(err => {
      alert(`Unable to add the product to cart. Please refresh and try again. Error: ${err}`)
    })
});